// saloni-quantity-selector

function appendViewNewProductCard(href) {
    if (!href) return '';
    if (href.indexOf('view=new_product_card') !== -1) return href;
    return href.indexOf('?') === -1 ? href + '?view=new_product_card' : href + '&view=new_product_card';
}

function initQuantitySelectorTracking() {
    if (window.__quantitySelectorInitialized) {
        return;
    }
    window.__quantitySelectorInitialized = true;

    window.QuantitySelector = class QuantitySelector {
        constructor() {
            if (window.QuantitySelector.instance) {
                return window.QuantitySelector.instance;
            }
            window.QuantitySelector.instance = this;
            this.init();
        }

        init() {
            // Listen for cart updates
            document.documentElement.addEventListener('cart:refresh', async (e) => {
                try {
                    // Skip if this is our own cart:refresh event with error
                    if (e.detail?.error) return;

                    // Use cart data from event or fetch if not available (ensure items array and item_count exist)
                    let cart = e.detail?.cart || await (await fetch('/cart.js')).json();
                    if (!cart || !Array.isArray(cart.items) || cart.item_count === undefined) {
                        cart = await (await fetch('/cart.js')).json();
                    }
                    window._lastShadeSheetCart = cart;

                    // Update header cart count (fixes "undefined" when adding from bottom sheet)
                    const itemCount = cart.item_count != null ? cart.item_count : 0;
                    document.querySelectorAll('.header__cart-count, cart-count.header__cart-count').forEach(el => {
                        el.textContent = itemCount;
                    });

                    // Update all variants with fresh cart data
                    cartQuantity = cartQuantity.map(item => {
                        const matchingCartItems = cart.items.filter(cartItem => cartItem.variant_id.toString() === item.id.toString());
                        const totalQty = matchingCartItems.reduce((sum, cartItem) => sum + cartItem.quantity, 0);

                        return {
                            ...item,
                            quantity: totalQty
                        };
                    });

                    // Update View Cart button count
                    document.querySelectorAll('.view-cart-btn-container .cart-count').forEach(btn => {
                        btn.textContent = itemCount;
                    });

                    // Get all product wrappers and sticky forms
                    const allProductWrappers = document.querySelectorAll('.product-item__cta-wrapper, .product-sticky-form, .product-form, .size-variant-sheet__row, .shade-variant-sheet__footer');

                    // Update each wrapper
                    allProductWrappers.forEach(wrapper => {
                        if (wrapper.classList.contains('size-variant-sheet__row')) {
                            // Use row's data-variant-id first, then quantity selector, then form input
                            const variantId = wrapper.dataset.variantId || wrapper.querySelector('.custom-quantity-selector')?.dataset.variantId || wrapper.querySelector('input[name="id"]')?.value;
                            if (!variantId) return;
                            const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());
                            const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                            this.updateUI(wrapper, totalQty, cart);
                        } else if (wrapper.classList.contains('shade-variant-sheet__footer')) {
                            const variantId = wrapper.querySelector('.custom-quantity-selector')?.dataset.variantId || wrapper.querySelector('input[name="id"]')?.value;
                            if (!variantId) return;
                            const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());
                            const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                            this.updateUI(wrapper, totalQty, cart);
                        } else if (wrapper.classList.contains('product-sticky-form') || wrapper.classList.contains('product-form')) {
                            // For sticky form, get the current variant ID
                            const currentVariantId = wrapper.querySelector('input[name="properties[_variant_id]"]')?.value;
                            if (!currentVariantId) return;

                            // Find if current variant is in cart
                            const matchingItems = cart.items.filter(item => item.variant_id.toString() === currentVariantId);
                            const variantQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);

                            // Update UI for current variant
                            this.updateUI(wrapper, variantQty, cart);
                        } else {
                            // For product cards (including Select Variant/Select Shade)
                            const quantitySelector = wrapper.querySelector('.custom-quantity-selector');
                            const variantInput = wrapper.querySelector('input[name="id"]');
                            const productId = quantitySelector?.dataset.productId || wrapper.dataset.productId;

                            if (productId) {
                                let matchingItems;
                                if (productId.includes(',')) {
                                    const productArray = productId
                                        .split(',')
                                        .map(id => id.trim())
                                        .filter(Boolean);
                                    matchingItems = cart.items.filter(item => productArray.includes(item.product_id.toString()));
                                } else {
                                    matchingItems = cart.items.filter(item => item.product_id.toString() === productId.toString());
                                }
                                const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                                this.updateUI(wrapper, totalQty, cart);
                            } else {
                                const variantId = variantInput?.value || quantitySelector?.dataset.variantId;
                                if (!variantId) return;

                                const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());
                                const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                                this.updateUI(wrapper, totalQty, cart);
                            }
                        }
                    });

                    // Update shade sheet swatch badges (cart quantity per variant)
                    document.querySelectorAll('.shade-variant-sheet').forEach(sheet => {
                        sheet.querySelectorAll('.shade-variant-sheet__swatch-wrap').forEach(wrap => {
                            const variantId = wrap.dataset.variantId;
                            if (!variantId) return;
                            const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());
                            const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                            const badge = wrap.querySelector('.shade-variant-sheet__swatch-cart-badge');
                            if (badge) {
                                badge.textContent = totalQty.toString();
                                badge.setAttribute('aria-label', totalQty + ' in cart');
                                if (totalQty === 0) {
                                    badge.setAttribute('hidden', 'true');
                                } else {
                                    badge.removeAttribute('hidden');
                                }
                            }
                        });
                    });

                    // Hide all loaders after UI update
                    this.hideAllLoaders();
                } catch (error) {
                    console.error('Failed to sync cart quantities:', error);
                    this.hideAllLoaders();
                }
            });

            // Listen for quantity selector clicks
            document.addEventListener('click', async (e) => {
                // Select Shade / Select Variant: show loader until drawer/popover loads
                const selectVariantBtn = e.target.closest('.pilgrim-card__cta--select-variant');
                if (selectVariantBtn) {
                    const card = selectVariantBtn.closest('product-item.product-item--pilgrim');
                    const cardType = card?.dataset?.cardType || '';
                    const sheetType = cardType === 'shade_variant' ? 'shade' : 'size';
                    const productId = card?.dataset?.productId || '';
                    const loader = selectVariantBtn.querySelector('.loader-button__loader');
                    const targetId = selectVariantBtn.getAttribute('aria-controls');
                    if (loader && targetId) {
                        loader.removeAttribute('hidden');
                        loader.removeAttribute('aria-hidden');
                        const target = document.getElementById(targetId);
                        if (target) {
                            let timeoutId;
                            const hideLoader = () => {
                                loader.setAttribute('hidden', 'true');
                                loader.setAttribute('aria-hidden', 'true');
                                target.removeEventListener('openable-element:load:end', hideLoader);
                                target.removeEventListener('openable-element:load:end', trackSheetOpen);
                                if (timeoutId) clearTimeout(timeoutId);
                            };
                            const trackSheetOpen = () => {
                                target.dataset.clpSheetType = sheetType;
                                target.dataset.clpSheetOpenedAt = String(Date.now());
                                target.dataset.clpSheetProductId = productId;
                            };
                            target.addEventListener('openable-element:load:end', hideLoader);
                            target.addEventListener('openable-element:load:end', trackSheetOpen);
                            timeoutId = setTimeout(hideLoader, 8000);
                        }
                    }
                    // Fallback: ensure quick-buy container opens even if toggle-button click handler is flaky.
                    if (targetId) {
                        const target = document.getElementById(targetId);
                        if (target && !target.hasAttribute('open')) {
                            target.setAttribute('open', '');
                        }
                    }
                }

                // Shade variant sheet Add button: use fetch to add to cart (keeps drawer open)
                const shadeVariantAddBtn = e.target.closest('.shade-variant-sheet__atc');
                if (shadeVariantAddBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    const form = shadeVariantAddBtn.closest('form');
                    if (!form) return;
                    const sheet = shadeVariantAddBtn.closest('.shade-variant-sheet');
                    const selectedWrap = sheet?.querySelector('.shade-variant-sheet__swatch-wrap .shade-variant-sheet__swatch.is-selected')?.closest('.shade-variant-sheet__swatch-wrap') || sheet?.querySelector('.shade-variant-sheet__swatch-wrap input[type="radio"]:checked')?.closest('.shade-variant-sheet__swatch-wrap');
                    const variantId = selectedWrap?.dataset?.variantId || form.querySelector('input[name="id"]')?.value;
                    const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);
                    if (!variantId) return;
                    const idInput = form.querySelector('input[name="id"]');
                    if (idInput) idInput.value = variantId;
                    if (shadeVariantAddBtn.disabled) return;
                    shadeVariantAddBtn.disabled = true;
                    shadeVariantAddBtn.setAttribute('aria-busy', 'true');
                    const addBtnLoader = sheet?.querySelector('.shade-variant-sheet__atc-loader');
                    if (addBtnLoader) {
                        addBtnLoader.removeAttribute('hidden');
                        addBtnLoader.removeAttribute('aria-hidden');
                        addBtnLoader.classList.add('is-loading');
                        addBtnLoader.style.setProperty('display', 'flex', 'important');
                        addBtnLoader.style.setProperty('visibility', 'visible', 'important');
                        addBtnLoader.style.setProperty('opacity', '1', 'important');
                        await new Promise(r => requestAnimationFrame(r));
                        await new Promise(r => requestAnimationFrame(r));
                    }
                    try {
                        const response = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
                        });
                        const addResult = await response.json();
                        if (!response.ok) throw new Error(addResult?.message || 'Failed to add item');
                        const cartData = await (await fetch('/cart.js')).json();
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));

                        if (sheet && cartData && cartData.items) {
                            const matchingItems = cartData.items.filter(item => item.variant_id.toString() === variantId.toString());
                            const totalQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
                            const footer = sheet.querySelector('.shade-variant-sheet__footer');
                            const atcWrap = footer?.querySelector('.shade-variant-sheet__atc-wrap');
                            const qtySel = footer?.querySelector('.shade-variant-sheet__qty');
                            if (footer && atcWrap && qtySel && totalQty > 0) {
                                atcWrap.style.setProperty('display', 'none', 'important');
                                qtySel.style.setProperty('display', 'flex', 'important');
                                qtySel.setAttribute('data-variant-id', variantId);
                                const valEl = qtySel.querySelector('.quantity-selector__value');
                                if (valEl) valEl.textContent = totalQty.toString();
                            }
                            const badgeWrap = sheet.querySelector('.shade-variant-sheet__swatch-wrap[data-variant-id="' + variantId + '"]');
                            const badge = badgeWrap?.querySelector('.shade-variant-sheet__swatch-cart-badge');
                            if (badge) {
                                badge.textContent = totalQty.toString();
                                badge.setAttribute('aria-label', totalQty + ' in cart');
                                badge.removeAttribute('hidden');
                            }
                        }
                    } catch (err) {
                        this.showErrorNotification(err.message);
                    } finally {
                        shadeVariantAddBtn.disabled = false;
                        shadeVariantAddBtn.removeAttribute('aria-busy');
                        if (addBtnLoader) {
                            addBtnLoader.classList.remove('is-loading');
                            addBtnLoader.setAttribute('hidden', 'true');
                            addBtnLoader.setAttribute('aria-hidden', 'true');
                            addBtnLoader.style.removeProperty('display');
                            addBtnLoader.style.removeProperty('visibility');
                            addBtnLoader.style.removeProperty('opacity');
                        }
                    }
                    return;
                }

                // Size variant sheet Add button: use fetch to add to cart (keeps drawer open)
                const sizeVariantAddBtn = e.target.closest('.size-variant-sheet__atc, .size-variant-sheet__add-btn');
                if (sizeVariantAddBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    const row = sizeVariantAddBtn.closest('.size-variant-sheet__row');
                    if (!row) return;
                    const variantId = row.dataset.variantId;
                    console.log('[CV/Kit ATC] handler fired | variantId:', variantId, '| rowProductId:', row.dataset.productId, '| row:', row);
                    const form = sizeVariantAddBtn.closest('form');
                    const quantity = parseInt(form?.querySelector('input[name="quantity"]')?.value || '1', 10);
                    if (!variantId) return;
                    const sizeSheet = row.closest('.size-variant-sheet');
                    const sheetContainer = row.closest('quick-buy-drawer, quick-buy-popover');
                    const openedAt = Number(sheetContainer?.dataset?.clpSheetOpenedAt || 0);
                    if (openedAt) {
                        delete sheetContainer.dataset.clpSheetOpenedAt;
                    }
                    if (sizeVariantAddBtn.disabled) return;
                    sizeVariantAddBtn.disabled = true;
                    sizeVariantAddBtn.setAttribute('aria-busy', 'true');
                    const addBtnLoader = sizeVariantAddBtn.querySelector('.loader-button__loader');
                    if (addBtnLoader) addBtnLoader.removeAttribute('hidden');
                    try {
                        console.log('[CV/Kit ATC] fetching /cart/add.js | id:', variantId, '| quantity:', quantity);
                        const response = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
                        });
                        const addResult = await response.json();
                        console.log('[CV/Kit ATC] add result:', addResult);
                        if (!response.ok) throw new Error(addResult?.message || 'Failed to add item');
                        const cartData = await (await fetch('/cart.js')).json();
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));
                    } catch (err) {
                        this.showErrorNotification(err.message);
                        if (addBtnLoader) addBtnLoader.setAttribute('hidden', 'true');
                    } finally {
                        sizeVariantAddBtn.disabled = false;
                        sizeVariantAddBtn.removeAttribute('aria-busy');
                    }
                    return;
                }

                // Pilgrim product card Add button: use fetch to add to cart (stays on collection page)
                const pilgrimAtcBtn = e.target.closest('.pilgrim-card__atc');
                if (pilgrimAtcBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    const form = pilgrimAtcBtn.closest('form');
                    if (!form) return;
                    const variantId = form.querySelector('input[name="id"]')?.value;
                    const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);
                    if (!variantId) return;
                    if (pilgrimAtcBtn.disabled) return;
                    pilgrimAtcBtn.disabled = true;
                    pilgrimAtcBtn.setAttribute('aria-busy', 'true');
                    pilgrimAtcBtn.classList.add('loading');
                    const addBtnLoader = pilgrimAtcBtn.querySelector('.loader-button__loader');
                    if (addBtnLoader) addBtnLoader.removeAttribute('hidden');
                    try {
                        const response = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
                        });
                        const addResult = await response.json();
                        if (!response.ok) throw new Error(addResult?.message || 'Failed to add item');
                        const cartData = await (await fetch('/cart.js')).json();
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));
                    } catch (err) {
                        this.showErrorNotification(err.message);
                        if (addBtnLoader) addBtnLoader.setAttribute('hidden', 'true');
                    } finally {
                        pilgrimAtcBtn.disabled = false;
                        pilgrimAtcBtn.removeAttribute('aria-busy');
                        pilgrimAtcBtn.classList.remove('loading');
                    }
                    return;
                }

                // Kit/CV variant in quick-buy drawer custom-sheet-variant-selector: intercept ATC submit
                const quickBuyAtcBtn = e.target.closest('#AddToCart, #StickyAddToCart');
                if (quickBuyAtcBtn) {
                    const form = quickBuyAtcBtn.closest('form');
                    const drawer = quickBuyAtcBtn.closest('quick-buy-drawer, quick-buy-popover');
                    if (form && drawer) {
                        const checkedKitRadio = drawer.querySelector('.block-swatch.kit-element .block-swatch__radio:checked');
                        if (checkedKitRadio) {
                            e.preventDefault();
                            e.stopPropagation();
                            let variantId;
                            if (checkedKitRadio.value === 'xyz') {
                                variantId = checkedKitRadio.closest('.block-swatch.kit-element')?.dataset?.kitVariantId;
                            } else if (checkedKitRadio.value.startsWith('cv-')) {
                                variantId = checkedKitRadio.value.replace('cv-', '');
                            }
                            if (!variantId) return;
                            const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || '1', 10);
                            if (quickBuyAtcBtn.disabled) return;
                            quickBuyAtcBtn.disabled = true;
                            quickBuyAtcBtn.setAttribute('aria-busy', 'true');
                            const addBtnLoader = quickBuyAtcBtn.querySelector('.loader-button__loader');
                            if (addBtnLoader) addBtnLoader.removeAttribute('hidden');
                            try {
                                const response = await fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
                                });
                                const addResult = await response.json();
                                if (!response.ok) throw new Error(addResult?.message || 'Failed to add item');
                                const cartData = await (await fetch('/cart.js')).json();
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));
                            } catch (err) {
                                this.showErrorNotification(err.message);
                                if (addBtnLoader) addBtnLoader.setAttribute('hidden', 'true');
                            } finally {
                                quickBuyAtcBtn.disabled = false;
                                quickBuyAtcBtn.removeAttribute('aria-busy');
                            }
                            return;
                        }
                    }
                }

                // Add click handler for View Cart button on product page
                const viewCartBtn = e.target.closest('.product-sticky-form .view-cart-btn');
                const miniCart = document.querySelector('cart-drawer');

                if (viewCartBtn && miniCart) {
                    miniCart.setAttribute('open', '');

                    // try {
                    //     posthog.capture('view_cart_button_clicked', {
                    //         page_type: 'product',
                    //         page_url: window.location.href
                    //     });
                    // } catch (error) {
                    //     console.warn('Analytics tracking failed:', error);
                    // }
                }

                const button = e.target.closest('.custom-quantity-selector__button');
                if (!button) return;

                // Prevent multiple clicks
                if (button.disabled) return;

                // Select Variant / Select Shade: custom Plus/Minus behavior
                const selectVariantQty = button.closest('.pilgrim-card__qty--select-variant');
                if (selectVariantQty) {
                    e.preventDefault();
                    e.stopPropagation();
                    const action = button.dataset.action;
                    const productId = selectVariantQty.dataset.productId;
                    const wrapper = selectVariantQty.closest('.product-item__cta-wrapper');
                    if (!wrapper || !productId) return;

                    const openDrawerOrPopover = () => {
                        const isMobile = window.matchMedia('(max-width: 739px)').matches;
                        const primaryBtn = isMobile
                            ? wrapper.querySelector('.pilgrim-card__cta--select-variant.hidden-tablet-and-up')
                            : wrapper.querySelector('.pilgrim-card__cta--select-variant.hidden-phone');
                        const fallbackBtn = wrapper.querySelector('.pilgrim-card__cta--select-variant');
                        const toggleBtn = primaryBtn || fallbackBtn;
                        if (!toggleBtn) return;
                        const targetId = toggleBtn.getAttribute('aria-controls');
                        const target = targetId ? document.getElementById(targetId) : null;
                        if (target && !target.open) {
                            target.open = true;
                        }
                    };

                    if (action === 'increase') {
                        const loader = selectVariantQty.querySelector('.loader-button__loader');
                        if (loader) {
                            loader.removeAttribute('hidden');
                            loader.removeAttribute('aria-hidden');
                            loader.style.cssText = 'position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:100%!important;margin:0!important;display:flex!important;align-items:center;justify-content:center;visibility:visible!important;opacity:1!important;z-index:10;background:rgba(255,255,255,0.8);border-radius:inherit;';
                            await new Promise(r => requestAnimationFrame(r));
                            await new Promise(r => requestAnimationFrame(r));
                        }
                        openDrawerOrPopover();
                        const isMobile = window.matchMedia('(max-width: 739px)').matches;
                        const toggleBtn = isMobile
                            ? wrapper.querySelector('.pilgrim-card__cta--select-variant.hidden-tablet-and-up')
                            : wrapper.querySelector('.pilgrim-card__cta--select-variant.hidden-phone');
                        const fallbackBtn = wrapper.querySelector('.pilgrim-card__cta--select-variant');
                        const targetToggleBtn = toggleBtn || fallbackBtn;
                        const targetId = targetToggleBtn?.getAttribute('aria-controls');
                        const target = targetId ? document.getElementById(targetId) : null;
                        if (target && loader) {
                            const hideLoader = () => {
                                loader.setAttribute('hidden', 'true');
                                target.removeEventListener('openable-element:load:end', hideLoader);
                            };
                            target.addEventListener('openable-element:load:end', hideLoader);
                            setTimeout(hideLoader, 8000);
                        } else if (loader) {
                            loader.setAttribute('hidden', 'true');
                        }
                        return;
                    }
                    if (action === 'decrease') {
                        const loader = selectVariantQty.querySelector('.loader-button__loader');
                        if (loader) {
                            loader.removeAttribute('hidden');
                            loader.removeAttribute('aria-hidden');
                            loader.style.cssText = 'position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:100%!important;margin:0!important;display:flex!important;align-items:center;justify-content:center;visibility:visible!important;opacity:1!important;z-index:10;background:rgba(255,255,255,0.8);border-radius:inherit;';
                            await new Promise(r => requestAnimationFrame(r));
                            await new Promise(r => requestAnimationFrame(r));
                        }
                        try {
                            const cart = await (await fetch('/cart.js')).json();
                            const productIds = productId.split(',').map(id => id.trim()).filter(Boolean);
                            const lineItems = cart.items.filter(item => productIds.includes(item.product_id.toString()));
                            // Single variant in cart: directly decrease quantity
                            if (lineItems.length === 1 && lineItems[0]) {
                                const item = lineItems[0];
                                const newQty = Math.max(0, item.quantity - 1);
                                await fetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ id: item.key, quantity: newQty })
                                });
                                const cartData = await (await fetch('/cart.js')).json();
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartData } }));
                            } else {
                                // Multiple variants in cart: open bottom sheet
                                openDrawerOrPopover();
                            }
                        } catch (err) {
                            this.showErrorNotification(err?.message || 'Failed to update cart');
                        } finally {
                            if (loader) loader.setAttribute('hidden', 'true');
                        }
                        return;
                    }
                }

                const action = button.dataset.action;
                const productId = button.closest('.custom-quantity-selector').dataset.productId;
                const variantId = button.closest('.custom-quantity-selector').dataset.variantId;
                const qvQtyButton = button.classList.contains('qv-qty-button');

                try {
                    let cartData;
                    if (action === 'increase' && !qvQtyButton) {
                        // Check max quantity first
                        const quantitySelector = button.closest('.custom-quantity-selector');
                        const maxQuantity = parseInt(quantitySelector?.dataset.maxQuantity, 10);
                        const currentQty = parseInt(quantitySelector?.querySelector('.quantity-selector__value')?.textContent, 10);

                        if (maxQuantity && currentQty == maxQuantity) {
                            // const productTitle = quantitySelector.closest('product-item').querySelector('.product-item-meta__title').textContent.trim();
                            // this.showErrorNotification(`Must have at most ${maxQuantity} of ${productTitle}`);
                            this.showErrorNotification(`Must have at most ${maxQuantity} of this item`);
                            return;
                        }

                        // Show loader on increase - force repaint so it's visible before async work
                        const loaderEl = button.closest('.custom-quantity-selector')?.querySelector('.loader-button__loader');
                        if (loaderEl) {
                            loaderEl.removeAttribute('hidden');
                            loaderEl.removeAttribute('aria-hidden');
                            loaderEl.style.cssText = 'position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:100%!important;margin:0!important;display:flex!important;align-items:center;justify-content:center;visibility:visible!important;opacity:1!important;z-index:10;background:rgba(255,255,255,0.8);border-radius:inherit;';
                            await new Promise(r => requestAnimationFrame(r));
                            await new Promise(r => requestAnimationFrame(r));
                        }

                        // First get current cart to find existing items
                        const currentCart = await (await fetch('/cart.js')).json();
                        const existingItems = currentCart.items.filter(item => item.variant_id.toString() === variantId.toString());

                        // Update the first item's quantity if it exists, otherwise add new item
                        if (existingItems.length > 0) {
                            const firstItem = existingItems[0];
                            const response = await fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    id: firstItem.key,
                                    quantity: firstItem.quantity + 1
                                })
                            });

                            cartData = await response.json();
                            if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                        } else {
                            // Add new item if none exists
                            const response = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    items: [{ id: variantId, quantity: 1 }]
                                })
                            });

                            cartData = await response.json();
                            if (!response.ok) throw new Error(cartData.message || 'Failed to add item');
                        }

                        // try {
                        //     posthog.capture('qs_plus_clicked', {
                        //         page_url: window.location.href,
                        //         product_id: productId,
                        //         variant_id: variantId
                        //     });
                        // } catch (error) {
                        //     console.warn('Analytics tracking failed:', error);
                        // }
                    } else if (action === 'decrease' && !qvQtyButton) {
                        // Show loader on decrease - force repaint so it's visible before async work
                        const loaderEl = button.closest('.custom-quantity-selector')?.querySelector('.loader-button__loader');
                        if (loaderEl) {
                            loaderEl.removeAttribute('hidden');
                            loaderEl.removeAttribute('aria-hidden');
                            loaderEl.style.cssText = 'position:absolute!important;top:0!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:100%!important;margin:0!important;display:flex!important;align-items:center;justify-content:center;visibility:visible!important;opacity:1!important;z-index:10;background:rgba(255,255,255,0.8);border-radius:inherit;';
                            await new Promise(r => requestAnimationFrame(r));
                            await new Promise(r => requestAnimationFrame(r));
                        }

                        // Get current cart to find all line items of this variant
                        const cart = await (await fetch('/cart.js')).json();
                        const lineItems = cart.items.filter(item => item.variant_id.toString() === variantId.toString());

                        if (lineItems.length > 0) {
                            // Calculate total quantity across all line items
                            const totalQty = lineItems.reduce((sum, item) => sum + item.quantity, 0);

                            if (totalQty === 1) {
                                // If total quantity is 1, remove all line items
                                for (const item of lineItems) {
                                    const response = await fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                            id: item.key,
                                            quantity: 0
                                        })
                                    });
                                    cartData = await response.json();
                                    if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                                }
                            } else {
                                // If total quantity > 1, decrease the first item's quantity
                                const firstItem = lineItems[0];
                                const response = await fetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        id: firstItem.key,
                                        quantity: firstItem.quantity - 1
                                    })
                                });

                                cartData = await response.json();
                                if (!response.ok) throw new Error(cartData.message || 'Failed to update item');
                            }
                        }

                        // try {
                        //     posthog.capture('qs_minus_clicked', {
                        //         page_url: window.location.href,
                        //         product_id: productId,
                        //         variant_id: variantId
                        //     });
                        // } catch (error) {
                        //     console.warn('Analytics tracking failed:', error);
                        // }
                    } else {
                        if (screen.width <= 740) {
                            let phone_btn = button.closest('product-item').querySelector('.custom-product-btn .hidden-tablet-and-up')
                            phone_btn.click();
                            button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');
                            document.querySelector(`#${phone_btn.getAttribute("aria-controls")}`).addEventListener("openable-element:load:end", () => {
                                button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').setAttribute('hidden', 'true')
                            });
                        } else {
                            let desk_btn = button.closest('product-item').querySelector('.custom-product-btn .hidden-phone');
                            desk_btn.click();
                            button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').removeAttribute('hidden');
                            document.querySelector(`#${desk_btn.getAttribute("aria-controls")}`).addEventListener("openable-element:load:end", () => {
                                button.closest('.custom-quantity-selector').querySelector('.loader-button__loader').setAttribute('hidden', 'true')
                            });
                        }
                    }

                    // Trigger cart refresh - ensure we have full cart (cart/add.js returns line item, not cart)
                    let cartForRefresh = cartData;
                    if (!cartForRefresh || cartForRefresh.item_count === undefined) {
                        cartForRefresh = await (await fetch('/cart.js')).json();
                    }
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: { cart: cartForRefresh }
                    }));
                } catch (error) {
                    console.error('Cart operation failed:', error);
                    this.showErrorNotification(error.message);
                    // Hide loader on error
                    button.closest('.custom-quantity-selector')?.querySelector('.loader-button__loader')?.setAttribute('hidden', 'true');
                }
            });

            // Kit/CV swatch change: update title, image, price in quick-buy drawer
            document.addEventListener('change', (e) => {
                const radio = e.target;
                if (!radio.matches('.block-swatch__radio')) return;
                const drawer = radio.closest('quick-buy-drawer, quick-buy-popover');
                if (!drawer) return;

                const kitSwatch = radio.closest('.block-swatch.kit-element');
                const titleEl = drawer.querySelector('.product-item-meta__title');
                const imgWrapper = drawer.querySelector('.quick-buy-product__image-wrapper');
                const priceList = drawer.querySelector('.quick-buy-drawer-form .price-list') || drawer.querySelector('.popover__content .price-list');

                const atcBtn = drawer.querySelector('[data-product-add-to-cart-button]');
                if (kitSwatch) {
                    if (titleEl && !titleEl.dataset.origTitle) titleEl.dataset.origTitle = titleEl.textContent.trim();
                    if (priceList && !priceList.dataset.origHtml) priceList.dataset.origHtml = priceList.innerHTML;

                    if (atcBtn) {
                        if (!atcBtn.dataset.origHtml) atcBtn.dataset.origHtml = atcBtn.innerHTML;
                        const kitAvailable = kitSwatch.dataset.kitAvailable !== 'false';
                        if (!kitAvailable) {
                            atcBtn.disabled = true;
                            atcBtn.style.opacity = '0.5';
                            atcBtn.style.cursor = 'not-allowed';
                            atcBtn.innerHTML = 'Sold Out';
                        } else {
                            atcBtn.disabled = false;
                            atcBtn.style.opacity = '';
                            atcBtn.style.cursor = '';
                            atcBtn.innerHTML = atcBtn.dataset.origHtml;
                        }
                    }

                    const kitTitle = kitSwatch.dataset.kitTitle;
                    if (titleEl && kitTitle) titleEl.textContent = kitTitle;

                    const priceHtml = kitSwatch.dataset.kitPriceHtml;
                    const compareHtml = kitSwatch.dataset.kitCompareHtml;
                    const pctOff = parseInt(kitSwatch.dataset.kitPctOff || '0', 10);
                    if (priceList && priceHtml) {
                        if (pctOff > 0 && compareHtml) {
                            priceList.innerHTML = `<span class="price price--highlight">${priceHtml}</span><span class="price price--compare">${compareHtml}</span><span class="discount-percentage">(${pctOff}% off)</span>`;
                        } else {
                            priceList.innerHTML = `<span class="price">${priceHtml}</span>`;
                        }
                    }

                    const kitImage = kitSwatch.dataset.kitImage;
                    if (imgWrapper && kitImage) {
                        if (!imgWrapper.dataset.lockedHeight) {
                            imgWrapper.dataset.lockedHeight = imgWrapper.clientHeight + 'px';
                        }
                        imgWrapper.style.height = imgWrapper.dataset.lockedHeight;
                        imgWrapper.style.overflow = 'hidden';
                        let overlay = imgWrapper.querySelector('.kit-img-overlay');
                        if (!overlay) {
                            overlay = document.createElement('img');
                            overlay.className = 'kit-img-overlay';
                            overlay.style.cssText = 'width:100%;height:100%;object-fit:contain;max-width:100%;display:block;border-radius:8px;';
                            imgWrapper.prepend(overlay);
                        }
                        overlay.src = kitImage;
                        overlay.style.display = 'block';
                        const mediaEl = imgWrapper.querySelector('product-media, .product__media-list');
                        if (mediaEl) mediaEl.style.display = 'none';
                    }

                    // Sync form inputs so cart:refresh can show -1+ for the kit variant
                    const kitVariantId = kitSwatch.dataset.kitVariantId || (radio.value.startsWith('cv-') ? radio.value.replace('cv-', '') : null);
                    if (kitVariantId) {
                        const formId = radio.getAttribute('form');
                        const form = (formId && drawer.querySelector(`form[id="${formId}"]`)) || (formId && document.getElementById(formId));
                        if (form) {
                            const idInput = form.querySelector('input[name="id"]');
                            if (idInput) { idInput.value = kitVariantId; idInput.disabled = false; }
                            const propInput = form.querySelector('input[name="properties[_variant_id]"]');
                            if (propInput) propInput.value = kitVariantId;
                            const variantContainer = form.querySelector('[data-variant-container]');
                            const qtySelector = variantContainer?.querySelector('.custom-quantity-selector');
                            if (qtySelector) qtySelector.dataset.variantId = kitVariantId;
                            // Immediately reflect cart state for this variant
                            const productFormDiv = form.closest('.product-form');
                            if (productFormDiv) {
                                (async () => {
                                    const cart = window._lastShadeSheetCart || await (await fetch('/cart.js')).json();
                                    const cartQty = cart.items.filter(i => i.variant_id.toString() === kitVariantId).reduce((s, i) => s + i.quantity, 0);
                                    this.updateUI(productFormDiv, cartQty, cart);
                                })();
                            }
                        }
                    }
                } else {
                    if (titleEl && titleEl.dataset.origTitle) {
                        titleEl.textContent = titleEl.dataset.origTitle;
                        delete titleEl.dataset.origTitle;
                    }
                    if (priceList && priceList.dataset.origHtml) {
                        priceList.innerHTML = priceList.dataset.origHtml;
                        delete priceList.dataset.origHtml;
                    }
                    if (imgWrapper) {
                        const overlay = imgWrapper.querySelector('.kit-img-overlay');
                        if (overlay) overlay.style.display = 'none';
                        const mediaEl = imgWrapper.querySelector('product-media, .product__media-list');
                        if (mediaEl) mediaEl.style.removeProperty('display');
                        imgWrapper.style.removeProperty('height');
                        imgWrapper.style.removeProperty('overflow');
                        delete imgWrapper.dataset.lockedHeight;
                    }
                    if (atcBtn && atcBtn.dataset.origHtml) {
                        atcBtn.disabled = false;
                        atcBtn.style.opacity = '';
                        atcBtn.style.cursor = '';
                        atcBtn.innerHTML = atcBtn.dataset.origHtml;
                        delete atcBtn.dataset.origHtml;
                    }
                    // Sync form inputs so the correct variant is submitted and cart:refresh shows -1+
                    const variantId = radio.dataset.variantId;
                    if (variantId) {
                        const formId = radio.getAttribute('form');
                        const form = (formId && drawer.querySelector(`form[id="${formId}"]`)) || (formId && document.getElementById(formId));
                        if (form) {
                            const idInput = form.querySelector('input[name="id"]');
                            if (idInput) { idInput.value = variantId; idInput.disabled = false; }
                            const propInput = form.querySelector('input[name="properties[_variant_id]"]');
                            if (propInput) propInput.value = variantId;
                            const variantContainer = form.querySelector('[data-variant-container]');
                            const qtySelector = variantContainer?.querySelector('.custom-quantity-selector');
                            if (qtySelector) qtySelector.dataset.variantId = variantId;
                            // Immediately reflect cart state for this variant
                            const productFormDiv = form.closest('.product-form');
                            if (productFormDiv) {
                                (async () => {
                                    const cart = window._lastShadeSheetCart || await (await fetch('/cart.js')).json();
                                    const cartQty = cart.items.filter(i => i.variant_id.toString() === variantId).reduce((s, i) => s + i.quantity, 0);
                                    this.updateUI(productFormDiv, cartQty, cart);
                                })();
                            }
                        }
                    }
                }
            });
        }

        async updateUI(wrapper, qty, cartData = null) {
            // Handle shade variant sheet footer - quantity selector + Add button
            if (wrapper.classList.contains('shade-variant-sheet__footer')) {
                const atcWrap = wrapper.querySelector('.shade-variant-sheet__atc-wrap');
                const quantitySelector = wrapper.querySelector('.custom-quantity-selector');
                if (qty === 0) {
                    if (atcWrap) atcWrap.style.setProperty('display', 'block', 'important');
                    if (quantitySelector) quantitySelector.style.setProperty('display', 'none', 'important');
                } else {
                    if (atcWrap) atcWrap.style.setProperty('display', 'none', 'important');
                    if (quantitySelector) {
                        quantitySelector.style.setProperty('display', 'flex', 'important');
                        const valueEl = quantitySelector.querySelector('.quantity-selector__value');
                        if (valueEl) valueEl.textContent = qty.toString();
                    }
                }
                return;
            }
            // Handle size variant bottom sheet case - each row updated independently
            if (wrapper.classList.contains('size-variant-sheet__row')) {
                const atcForm = wrapper.querySelector('.size-variant-sheet__form');
                const atcButton = wrapper.querySelector('.size-variant-sheet__atc, .size-variant-sheet__add-btn');
                const quantitySelector = wrapper.querySelector('.custom-quantity-selector');
                if (qty === 0) {
                    if (atcForm) atcForm.style.removeProperty('display');
                    if (atcButton) atcButton.style.removeProperty('display');
                    if (quantitySelector) quantitySelector.style.setProperty('display', 'none', 'important');
                } else {
                    if (atcForm) atcForm.style.setProperty('display', 'none', 'important');
                    if (atcButton) atcButton.style.setProperty('display', 'none', 'important');
                    if (quantitySelector) {
                        quantitySelector.style.setProperty('display', 'flex', 'important');
                        const valueElement = quantitySelector.querySelector('.quantity-selector__value');
                        if (valueElement) valueElement.textContent = qty.toString();
                    }
                }
                return;
            }

            // Handle sticky form and product form case
            if (wrapper.classList.contains('product-sticky-form') || wrapper.classList.contains('product-form')) {
                const atcButton = wrapper.querySelector('#StickyAddToCart') || wrapper.querySelector('#AddToCart');
                const viewCartBtnContainer = wrapper.querySelector('.view-cart-btn-container');
                const formInfoContainer = wrapper.querySelector('.product-sticky-form__info');
                const variantContainer = wrapper.querySelector('[data-variant-container]');
                if (!variantContainer) return;

                const quantitySelector = variantContainer.querySelector('.custom-quantity-selector');
                if (!quantitySelector) return;

                const variantId = quantitySelector.dataset.variantId;
                if (!variantId) return;

                // Use provided cart data or fetch if not available
                const cart = cartData || await (await fetch('/cart.js')).json();

                // Find if variant is in cart and its quantity
                const matchingItems = cart.items.filter(item => item.variant_id.toString() === variantId);
                const variantQty = matchingItems.reduce((sum, item) => sum + item.quantity, 0);

                // Update UI based on cart quantity (only add class to sticky form, not main product form)
                const stickyForm = wrapper.classList?.contains('product-sticky-form') ? wrapper : null;
                if (variantQty === 0) {
                    // Show ATC button, hide quantity selector
                    if (stickyForm) stickyForm.classList.remove('sticky-form--qty-state');
                    if (quantitySelector) {
                        quantitySelector.style.display = 'none';
                        // Wait for the display none to take effect
                        await new Promise(resolve => setTimeout(resolve, 50));
                    }
                    if (atcButton) atcButton.style.display = 'block';
                    if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'none';
                    if (formInfoContainer) formInfoContainer.classList.remove('hidden-pocket');
                } else {
                    // Hide ATC button, show and update quantity selector
                    if (stickyForm) stickyForm.classList.add('sticky-form--qty-state');
                    if (atcButton) {
                        atcButton.style.display = 'none';
                        // Wait for the display none to take effect
                        await new Promise(resolve => setTimeout(resolve, 50));
                    }
                    if (quantitySelector) {
                        quantitySelector.style.display = 'flex';
                        const valueElement = quantitySelector.querySelector('.quantity-selector__value');
                        if (valueElement) valueElement.textContent = variantQty.toString();
                    }
                    if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'flex';
                    if (formInfoContainer) formInfoContainer.classList.add('hidden-pocket');
                }
                return;
            }

            // Handle Select Variant / Select Shade card case
            const selectVariantBtns = wrapper.querySelectorAll('.pilgrim-card__cta--select-variant');
            const selectVariantQtySelector = wrapper.querySelector('.pilgrim-card__qty--select-variant');
            if (selectVariantBtns.length > 0 || selectVariantQtySelector) {
                if (qty === 0) {
                    selectVariantBtns.forEach(btn => btn.style.removeProperty('display'));
                    if (selectVariantQtySelector) selectVariantQtySelector.style.setProperty('display', 'none', 'important');
                } else {
                    selectVariantBtns.forEach(btn => btn.style.setProperty('display', 'none', 'important'));
                    if (selectVariantQtySelector) {
                        selectVariantQtySelector.style.setProperty('display', 'flex', 'important');
                        const valueEl = selectVariantQtySelector.querySelector('.quantity-selector__value');
                        if (valueEl) valueEl.textContent = qty.toString();
                    }
                }
                return;
            }

            // Handle product card case (normal cards with Add to Cart, including Pilgrim)
            const productItem = wrapper.closest('product-item');
            if (!productItem) return;

            const atcForm = productItem.querySelector('.custom-product-btn');
            const atcBtn = productItem.querySelector('.pilgrim-card__atc');
            const quantitySelector = productItem.querySelector('.custom-quantity-selector');

            if (qty === 0) {
                // Show ATC form and button, hide quantity selector
                if (atcForm) atcForm.style.display = 'block';
                if (atcBtn) atcBtn.style.removeProperty('display');
                if (quantitySelector) quantitySelector.style.display = 'none';
            } else {
                // Hide ATC form, show and update quantity selector
                if (atcForm) atcForm.style.display = 'none';
                if (quantitySelector) {
                    quantitySelector.style.display = 'flex';
                    const valueElement = quantitySelector.querySelector('.quantity-selector__value');
                    if (valueElement) valueElement.textContent = qty.toString();
                }
            }
        }

        showErrorNotification(message) {
            const cartNotification = document.querySelector('.cart-notification');
            if (!cartNotification) return;

            cartNotification.classList.add('cart-notification--error');
            cartNotification.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${message}</span>
              </div>
              <button class="cart-notification__close tap-area hidden-phone" data-action="close">
                <span class="visually-hidden">Close</span>
                <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
                  <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      `;

            const cartNotificationError = document.querySelector('.cart-notification-error');
            if (cartNotificationError) {
                cartNotificationError.style.display = 'flex';
                cartNotificationError.querySelector('.cart-notification-error-text').textContent = message;
                setTimeout(() => {
                    cartNotificationError.style.display = 'none';
                }, 3000);
            }

            // Add click handler for close button
            const closeButton = cartNotification.querySelector('.cart-notification__close');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    cartNotification.setAttribute('hidden', '');
                });
            }

            cartNotification.removeAttribute('hidden');

            // Auto-hide after 3 seconds
            setTimeout(() => {
                cartNotification.setAttribute('hidden', '');
            }, 3000);
        }

        hideAllLoaders() {
            document.querySelectorAll('.custom-quantity-selector .loader-button__loader, .size-variant-sheet__add-btn .loader-button__loader, .pilgrim-card__atc .loader-button__loader, .pilgrim-card__cta--select-variant .loader-button__loader, .shade-variant-sheet__atc .loader-button__loader, .shade-variant-sheet__atc-loader').forEach(loader => {
                loader.classList.remove('is-loading');
                loader.setAttribute('hidden', 'true');
                loader.style.removeProperty('display');
                loader.style.removeProperty('visibility');
                loader.style.removeProperty('opacity');
            });
        }
    }

    // Initialize the quantity selector
    new QuantitySelector();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantitySelectorTracking);
} else {
    initQuantitySelectorTracking();
}

class QtyBox extends HTMLDivElement {
    connectedCallback() {
        const atcButton = this.closest('product-sticky-form')?.querySelector('#StickyAddToCart') || this.closest('.product-form')?.querySelector('#AddToCart');
        let quantity = cartQuantity.find(item => item.id.toString() === this.dataset.variantId.toString());
        const viewCartBtnContainer = this.closest('product-sticky-form')?.querySelector('.view-cart-btn-container');
        const formInfoContainer = this.closest('product-sticky-form')?.querySelector('.product-sticky-form__info');

        // If variant not in cartQuantity array, add it with quantity 0
        if (!quantity) {
            quantity = {
                id: Number(this.dataset.variantId),
                product_id: Number(this.dataset.productId),
                quantity: 0
            };
            cartQuantity.push(quantity);
        }

        // Update UI based on quantity
        if (quantity.quantity > 0) {
            if (atcButton) atcButton.style.display = 'none';
            this.style.display = 'flex';
            const valueElement = this.querySelector('.quantity-selector__value');
            if (valueElement) valueElement.textContent = quantity.quantity;
            if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'flex';
            if (formInfoContainer) formInfoContainer.classList.add('hidden-pocket');
        } else {
            if (atcButton) atcButton.style.display = 'block';
            this.style.display = 'none';
            if (viewCartBtnContainer) viewCartBtnContainer.style.display = 'none';
            if (formInfoContainer) formInfoContainer.classList.remove('hidden-pocket');
        }

        // Update View Cart button count based on cartQuantity array
        const viewCartCountElement = document.querySelectorAll('.view-cart-btn-container .cart-count');
        if (viewCartCountElement) {
            const totalQuantity = cartQuantity.reduce((sum, item) => sum + item.quantity, 0);
            viewCartCountElement.forEach(btn => {
                btn.textContent = totalQuantity;
            });
        }

        // const addToCartButton = document.querySelectorAll('.custom-product-btn.product-item__cta, #AddToCart');
        // addToCartButton.forEach(function (button) {
        //     button.addEventListener('click', function () {
        //         try {
        //             posthog.capture('atc_button_clicked', {
        //                 page_url: window.location.href,
        //                 product_id: button.closest('form').querySelector('[name="product-id"]').value,
        //                 variant_id: button.closest('form').querySelector('[name="id"]').value
        //             });
        //         } catch (error) {
        //             console.warn('Analytics tracking failed:', error);
        //         }
        //     });
        // });

        // const stickyAtcButton = document.querySelector('#StickyAddToCart');
        // if (stickyAtcButton) {
        //     stickyAtcButton.addEventListener('click', function () {
        //         const productSticky = this.closest('product-sticky-form');
        //         try {
        //             posthog.capture('atc_button_clicked', {
        //                 page_url: window.location.href,
        //                 product_id: productSticky?.querySelector('.custom-quantity-selector')?.dataset.productId,
        //                 variant_id: productSticky?.querySelector('[name="properties[_variant_id]"]')?.value
        //             });
        //         } catch (error) {
        //             console.warn('Analytics tracking failed:', error);
        //         }
        //     });
        // }
    }
}
customElements.define('qty-box', QtyBox, { extends: 'div' });

/* Shade variant sheet: carousel filter on swatch selection (event delegation for dynamically loaded content) */
function handleShadeSheetSwatchSelect(wrap) {
  if (!wrap || wrap.classList.contains('is-disabled')) return;
  const sheet = wrap.closest('.shade-variant-sheet');
  if (!sheet) return;

  const headerTitle = sheet.querySelector('.shade-variant-sheet__title');
  const footerShade = sheet.querySelector('.shade-variant-sheet__footer-shade');
  const footerPrice = sheet.querySelector('.shade-variant-sheet__footer-price .shade-variant-sheet__price');
  const footerCompare = sheet.querySelector('.shade-variant-sheet__footer-price .shade-variant-sheet__compare-price');
  const footerSavings = sheet.querySelector('.shade-variant-sheet__savings');
  const form = sheet.querySelector('.shade-variant-sheet__form');
  const soldOutSpan = sheet.querySelector('.shade-variant-sheet__sold-out');

  const title = wrap.getAttribute('data-variant-title');
  const price = wrap.getAttribute('data-price');
  const compare = wrap.getAttribute('data-compare-price');
  const savings = wrap.getAttribute('data-savings');
  const available = wrap.getAttribute('data-available') === 'true';
  const variantId = wrap.getAttribute('data-variant-id');
  const label = wrap.querySelector('label');

  if (headerTitle) {
    const baseTitle = headerTitle.getAttribute('data-base-title') || '';
    headerTitle.textContent = baseTitle || '';
  }
  if (footerShade) footerShade.textContent = title || '';
  if (footerPrice) footerPrice.textContent = price || '';
  const hasDiscount = parseInt(savings, 10) > 0;
  const pricesDiffer = compare && price && (String(compare).trim() !== String(price).trim());
  if (footerCompare) { footerCompare.textContent = compare || ''; footerCompare.style.display = (hasDiscount && pricesDiffer) ? '' : 'none'; }
  if (footerSavings) { footerSavings.textContent = savings ? savings + '% off' : ''; footerSavings.style.display = hasDiscount ? '' : 'none'; }
  if (form) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
  }
  const qtySel = sheet.querySelector('.shade-variant-sheet__qty');
  if (qtySel) qtySel.setAttribute('data-variant-id', variantId);
  const viewDetails = sheet.querySelector('.shade-variant-sheet__view-details');
  if (viewDetails) {
    const base = viewDetails.getAttribute('data-base-url') || '';
    const hrefWithVariant = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variantId;
    viewDetails.href = appendViewNewProductCard(hrefWithVariant);
  }
  const atcWrap = sheet.querySelector('.shade-variant-sheet__atc-wrap');
  if (atcWrap && !available) atcWrap.style.display = 'none';
  if (soldOutSpan) soldOutSpan.style.display = available ? 'none' : '';

  sheet.querySelectorAll('.shade-variant-sheet__swatch').forEach(function(s) { s.classList.remove('is-selected'); });
  if (label) label.classList.add('is-selected');

  function normalizeVal(s) {
    return (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }
  const optionValue = normalizeVal(title);
  const carouselInner = sheet.querySelector('.shade-variant-sheet__carousel-inner');
  const allSlides = sheet.querySelectorAll('.shade-variant-sheet__carousel-slide');
  const allDots = sheet.querySelectorAll('.shade-variant-sheet__carousel-dot');
  let firstVisibleIdx = -1;
  function matchesVariant(el) {
    if (el.getAttribute('data-is-global') === 'true') return true;
    const altVal = normalizeVal(el.getAttribute('data-alt-value'));
    if (!altVal) return true;
    if (!optionValue) return true;
    if (altVal === optionValue) return true;
    if (optionValue.indexOf(altVal) === 0) return true;
    if (altVal.indexOf(optionValue) === 0) return true;
    return false;
  }
  allSlides.forEach(function(slide, i) {
    const show = matchesVariant(slide);
    slide.style.display = show ? '' : 'none';
    if (show && firstVisibleIdx < 0) firstVisibleIdx = i;
  });
  allDots.forEach(function(dot) {
    const show = matchesVariant(dot);
    dot.style.display = show ? '' : 'none';
  });
  if (carouselInner && firstVisibleIdx >= 0) {
    carouselInner.scrollTo({ left: 0, behavior: 'smooth' });
    allDots.forEach(function(d) { d.classList.remove('is-active'); });
    allSlides.forEach(function(s) { s.classList.remove('is-selected'); });
    const dot = sheet.querySelector('.shade-variant-sheet__carousel-dot[data-index="' + firstVisibleIdx + '"]');
    const slide = sheet.querySelector('.shade-variant-sheet__carousel-slide[data-index="' + firstVisibleIdx + '"]');
    if (dot) dot.classList.add('is-active');
    if (slide) slide.classList.add('is-selected');
  }

  function updateShadeSheetFooter(cart, vId) {
    if (!cart || !Array.isArray(cart.items)) return;
    var matchingItems = cart.items.filter(function(item) { return item.variant_id.toString() === String(vId); });
    var totalQty = matchingItems.reduce(function(sum, item) { return sum + item.quantity; }, 0);
    var footer = sheet.querySelector('.shade-variant-sheet__footer');
    var atcWrap = footer && footer.querySelector('.shade-variant-sheet__atc-wrap');
    var qtySel = footer && footer.querySelector('.shade-variant-sheet__qty');
    if (footer && atcWrap && qtySel && available) {
      if (totalQty === 0) {
        atcWrap.style.setProperty('display', 'block', 'important');
        qtySel.style.setProperty('display', 'none', 'important');
      } else {
        atcWrap.style.setProperty('display', 'none', 'important');
        qtySel.style.setProperty('display', 'flex', 'important');
        var valEl = qtySel.querySelector('.quantity-selector__value');
        if (valEl) valEl.textContent = totalQty.toString();
      }
    }
  }

  if (window._lastShadeSheetCart) updateShadeSheetFooter(window._lastShadeSheetCart, variantId);

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    window._lastShadeSheetCart = cart;
    updateShadeSheetFooter(cart, variantId);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
  });
}

document.addEventListener('change', function(e) {
  const radio = e.target;
  if (!radio || radio.type !== 'radio' || !radio.closest('.shade-variant-sheet__swatch-wrap')) return;
  handleShadeSheetSwatchSelect(radio.closest('.shade-variant-sheet__swatch-wrap'));
});

document.addEventListener('click', function(e) {
  const wrap = e.target.closest('.shade-variant-sheet__swatch-wrap:not(.is-disabled)');
  if (wrap && wrap.closest('.shade-variant-sheet')) {
    const radio = wrap.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }
  const filterBtn = e.target.closest('.shade-variant-sheet__filter-btn');
  if (filterBtn) {
    const sheet = filterBtn.closest('.shade-variant-sheet');
    if (!sheet) return;
    sheet.querySelectorAll('.shade-variant-sheet__filter-btn').forEach(function(b) { b.classList.remove('is-active'); });
    filterBtn.classList.add('is-active');
    const names = (filterBtn.getAttribute('data-variant-names') || '').split('|').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
    sheet.querySelectorAll('.shade-variant-sheet__swatch-wrap').forEach(function(w) {
      const optVal = (w.getAttribute('data-option-value') || '').toLowerCase();
      const varTitle = (w.getAttribute('data-variant-title') || '').toLowerCase();
      const show = names.length === 0 || names[0] === 'all' || names.some(function(n) { return optVal === n || varTitle === n || optVal.indexOf(n) >= 0 || n.indexOf(optVal) >= 0; });
      w.style.display = show ? '' : 'none';
    });
  }
});

function trackShadeSwatchImpression(sheet) {
  if (!sheet || sheet.dataset.shadeImpressionTracked === 'true') return;
  sheet.dataset.shadeImpressionTracked = 'true';
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.shade-variant-sheet').forEach(function(sheet) {
    trackShadeSwatchImpression(sheet);
  });
});

var shadeSheetObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      var sheet = node.classList && node.classList.contains('shade-variant-sheet') ? node : node.querySelector && node.querySelector('.shade-variant-sheet');
      if (sheet) {
        trackShadeSwatchImpression(sheet);
        var sel = sheet.querySelector('.shade-variant-sheet__swatch.is-selected');
        var wrap = sel && sel.closest('.shade-variant-sheet__swatch-wrap');
        if (wrap) handleShadeSheetSwatchSelect(wrap);
      }
    });
  });
});
shadeSheetObserver.observe(document.body, { childList: true, subtree: true });
